import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { selectAllClassifications } from "../../../../redux/slices/classificationsSlice";
import { selectAllP2pSettings } from "../../../../redux/slices/p2pSettingsSlice";
import BackButtonSection from "./BackButtonSection";

const ConnectedBackButtonSection = ({ controlId }) => {
    const classifications = useSelector(selectAllClassifications);
    const { enableClassifications } = useSelector(selectAllP2pSettings);
    const hasClassifications =
        enableClassifications && classifications.length > 0;
    const backButtonProps = { hasClassifications, controlId };

    return <BackButtonSection {...backButtonProps} />;
};

ConnectedBackButtonSection.propTypes = {
    controlId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
};

export default ConnectedBackButtonSection;
